import React, {useState} from 'react';
import {useSwipeable} from 'react-swipeable';

import './Carousel.sass';
import {Controller} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Onboarding/components/Carousel/Controller/Controller';

export const CarouselItem = ({children, width}) => (
  <div className="create_flow__carousel__inner__item" style={{width}}>
    {children}
  </div>
);

export const Carousel = ({children, activeIndexCallback, onClickDone}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const updateIndex = (newIndex) => {
    const numberOfItems = React.Children.count(children);

    if (newIndex < 0) {
      newIndex = 0;
    } else if (newIndex >= numberOfItems) {
      newIndex = numberOfItems - 1;
    }

    activeIndexCallback && activeIndexCallback(newIndex);

    setActiveIndex(newIndex);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => updateIndex(activeIndex + 1),
    onSwipedRight: () => updateIndex(activeIndex - 1),
  });

  return (
    <div {...handlers} className="create_flow__carousel">
      <div
        className="create_flow__carousel__inner"
        style={{transform: `translateX(-${activeIndex * 100}%)`}}
      >
        {children}
      </div>

      <Controller
        updateIndex={updateIndex}
        activeIndex={activeIndex}
        children={children}
        quantityOfItems={children?.length}
        onClickDone={onClickDone}
      />
    </div>
  );
};
